import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
import { get, isEmpty, set } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { DEFAULT_AMORTIZATION_YEARS_VALUE, DEFAULT_COMPOUNDED_PERIOD_VALUE, DEFAULT_LOAN_TYPE_VALUE, DEFAULT_COAPP_VALUE, DEFAULT_INCLUDE_IN_TDS_VALUE, DEFAULT_INCOME_PERIOD_VALUE, DEFAULT_LANGUAGE_PREFERENCE, DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF, FLOWS_FOR_DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF, DEFAULT_NUM_CHILDREN } from "./application-default-values-constants";
import { applicationHasCoApplicants, hasApplicationValue } from "./util-functions";
import { removeEmptyKeys } from "@Shared/utils/utils";
export const setDefaultSubmissionDetailsAmortization = applicationObject => {
  const submissionDetails = get(applicationObject, "submission-details") || [];
  if (submissionDetails.length > 0) {
    set(applicationObject, "submission-details", _mapInstanceProperty(submissionDetails).call(submissionDetails, details => {
      const amortizationYears = get(details, "[submission-details][amortization-years]");
      if (!hasApplicationValue(amortizationYears)) {
        set(details, "[submission-details][amortization-years]", DEFAULT_AMORTIZATION_YEARS_VALUE);
      }
      return details;
    }));
  }
  return applicationObject;
};
export const setDefaultSubmissionDetailsCompoundedPeriod = applicationObject => {
  const submissionDetails = get(applicationObject, "submission-details") || [];
  if (submissionDetails.length > 0) {
    set(applicationObject, "submission-details", _mapInstanceProperty(submissionDetails).call(submissionDetails, details => {
      const compoundedPeriod = get(details, "[submission-details][compounded-period]");
      if (!hasApplicationValue(compoundedPeriod)) {
        set(details, "[submission-details][compounded-period]", DEFAULT_COMPOUNDED_PERIOD_VALUE);
      }
      return details;
    }));
  }
  return applicationObject;
};
export const setDefaultSubmissionDetailsLoanType = applicationObject => {
  const submissionDetails = get(applicationObject, "submission-details") || [];
  if (submissionDetails.length > 0) {
    set(applicationObject, "submission-details", _mapInstanceProperty(submissionDetails).call(submissionDetails, details => {
      const loanType = get(details, "[submission-details][loan-type]");
      const mortgageType = get(details, "[submission-details][mortgage-type]");
      if (hasApplicationValue(mortgageType) && !hasApplicationValue(loanType)) {
        set(details, "[submission-details][loan-type]", DEFAULT_LOAN_TYPE_VALUE);
      }
      return details;
    }));
  }
  return applicationObject;
};
export const setDefaultQuailifiyinhDetailsAmortizationYears = applicationObject => {
  const submissionDetails = get(applicationObject, "submission-details") || [];
  if (submissionDetails.length > 0) {
    set(applicationObject, "submission-details", _mapInstanceProperty(submissionDetails).call(submissionDetails, details => {
      const amortizationYears = get(details, "[qualifying-details][amortization-years]");
      if (!hasApplicationValue(amortizationYears)) {
        set(details, "[qualifying-details][amortization-years]", DEFAULT_AMORTIZATION_YEARS_VALUE);
      }
      return details;
    }));
  }
  return applicationObject;
};
export const setMainApplicantCoapp = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  const coapp = get(mainApplicant, "[personal-details][coapp]");
  if (!hasApplicationValue(coapp)) {
    set(mainApplicant, "[personal-details][coapp]", DEFAULT_COAPP_VALUE);
  }
  return applicationObject;
};
export const setDefaultPropertyIncludeInTds = applicationObject => {
  const property = get(applicationObject, "property");
  const includeInTds = get(property, "[costs][include-in-tds]");
  if (!hasApplicationValue(includeInTds)) {
    set(property, "[costs][include-in-tds]", DEFAULT_INCLUDE_IN_TDS_VALUE);
  }
  return applicationObject;
};
export const setDefaultMainApplicantOtherPropertiesIncludeInTds = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  const otherProperties = get(mainApplicant, "other-properties");
  if (otherProperties.length > 0) {
    const otherPropertiesWithData = _filterInstanceProperty(otherProperties).call(otherProperties, otherProperty => !isEmpty(removeEmptyKeys(otherProperty)));
    set(mainApplicant, "other-properties", _mapInstanceProperty(otherPropertiesWithData).call(otherPropertiesWithData, property => {
      const propertyCosts = get(property, "property-costs");
      const includeInTds = get(propertyCosts, "include-in-tds");
      if (!hasApplicationValue(includeInTds)) {
        return _objectSpread(_objectSpread({}, property), {}, {
          "property-costs": _objectSpread(_objectSpread({}, propertyCosts), {}, {
            "include-in-tds": DEFAULT_INCLUDE_IN_TDS_VALUE
          })
        });
      }
      return property;
    }));
  }
  return applicationObject;
};
export const setDefaultCoApplicantsOtherPropertiesIncludeInTds = applicationObject => {
  //do nothing if there are no co-applicants
  if (!applicationHasCoApplicants(applicationObject)) return applicationObject;
  const coApplicants = get(applicationObject, "co-applicants");
  if (coApplicants.length > 0) {
    coApplicants.forEach(applicant => {
      const otherProperties = get(applicant, "other-properties") || [];
      if (otherProperties.length > 0) {
        const otherPropertiesWithData = _filterInstanceProperty(otherProperties).call(otherProperties, otherProperty => !isEmpty(removeEmptyKeys(otherProperty)));
        set(applicant, "other-properties", _mapInstanceProperty(otherPropertiesWithData).call(otherPropertiesWithData, property => {
          const propertyCosts = get(property, "property-costs");
          const includeInTds = get(propertyCosts, "include-in-tds");
          if (!hasApplicationValue(includeInTds)) {
            return _objectSpread(_objectSpread({}, property), {}, {
              "property-costs": _objectSpread(_objectSpread({}, propertyCosts), {}, {
                "include-in-tds": DEFAULT_INCLUDE_IN_TDS_VALUE
              })
            });
          }
          return property;
        }));
      }
    });
  }
  return applicationObject;
};
export const setDefaultCoApplicantsId = applicationObject => {
  //do nothing if there are no co-applicants
  if (!applicationHasCoApplicants(applicationObject)) return applicationObject;
  const coApplicants = get(applicationObject, "co-applicants") || [];
  if (coApplicants.length > 0) {
    coApplicants.forEach(applicant => {
      const applicantId = get(applicant, "id");
      if (!hasApplicationValue(applicantId)) {
        set(applicant, "id", uuidv4());
      }
    });
  }
  return applicationObject;
};
export const setDefaultMainApplicantEmploymentIncomePeriod = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  if (mainApplicant) {
    const employment = get(mainApplicant, "employment") || [];
    if (employment.length > 0) {
      set(mainApplicant, "employment", _mapInstanceProperty(employment).call(employment, employment => {
        const incomePeriod = get(employment, "income-period");
        if (hasApplicationValue(incomePeriod)) return employment;
        return _objectSpread(_objectSpread({}, employment), {}, {
          "income-period": DEFAULT_INCOME_PERIOD_VALUE
        });
      }));
    }
  }
  return applicationObject;
};
export const setDefaultCoApplicantsEmploymentIncomePeriod = applicationObject => {
  //do nothing if there are no co-applicants
  if (!applicationHasCoApplicants(applicationObject)) return applicationObject;
  const coApplicants = get(applicationObject, "co-applicants") || [];
  if (coApplicants.length > 0) {
    coApplicants.forEach(applicant => {
      const employment = get(applicant, "employment") || [];
      if (employment.length > 0) {
        set(applicant, "employment", _mapInstanceProperty(employment).call(employment, employment => {
          const incomePeriod = get(employment, "income-period");
          if (hasApplicationValue(incomePeriod)) return employment;
          return _objectSpread(_objectSpread({}, employment), {}, {
            "income-period": DEFAULT_INCOME_PERIOD_VALUE
          });
        }));
      }
    });
  }
  return applicationObject;
};
export const setDefaultMainApplicantOtherIncomePeriod = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  const otherIncome = get(mainApplicant, "other-income");
  if (otherIncome.length > 0) {
    set(mainApplicant, "other-income", _mapInstanceProperty(otherIncome).call(otherIncome, otherIncome => {
      if (hasApplicationValue(otherIncome["income-period"])) return otherIncome;
      return _objectSpread(_objectSpread({}, otherIncome), {}, {
        "income-period": DEFAULT_INCOME_PERIOD_VALUE
      });
    }));
  }
  return applicationObject;
};
export const setDefaultCoApplicantsOtherIncomePeriod = applicationObject => {
  //do nothing if there are no co-applicants
  if (!applicationHasCoApplicants(applicationObject)) return applicationObject;
  const coApplicants = applicationObject["co-applicants"] || [];
  if (coApplicants.length > 0) {
    coApplicants.forEach(applicant => {
      const otherIncome = get(applicant, "other-income") || [];
      if (otherIncome.length > 0) {
        set(applicant, "other-income", _mapInstanceProperty(otherIncome).call(otherIncome, otherIncome => {
          const incomePeriod = get(otherIncome, "income-period");
          if (hasApplicationValue(incomePeriod)) return otherIncome;
          return _objectSpread(_objectSpread({}, otherIncome), {}, {
            "income-period": DEFAULT_INCOME_PERIOD_VALUE
          });
        }));
      }
    });
  }
  return applicationObject;
};
export const setDefaultMainApplicantPreferredLanguage = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  const preferredLanguage = get(mainApplicant, "[personal-details][language-preference]");
  if (!hasApplicationValue(preferredLanguage)) {
    set(mainApplicant, "[personal-details][language-preference]", DEFAULT_LANGUAGE_PREFERENCE);
  }
  return applicationObject;
};
export const setDefaultMainApplicantNumChildren = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  const numChildren = get(mainApplicant, "[personal-details][num-children]");
  if (!hasApplicationValue(numChildren)) {
    set(mainApplicant, "[personal-details][num-children]", DEFAULT_NUM_CHILDREN);
  }
  return applicationObject;
};
export const setDefaultCoApplicantsPreferredLanguage = applicationObject => {
  var _applicationObject$ma, _applicationObject$ma2, _applicationObject$ma3;
  //do nothing if there are no co-applicants
  if (!applicationHasCoApplicants(applicationObject)) return applicationObject;
  const coApplicants = applicationObject["co-applicants"] || [];
  const defaultLanguage = (_applicationObject$ma = applicationObject == null ? void 0 : (_applicationObject$ma2 = applicationObject["main-applicant"]) == null ? void 0 : (_applicationObject$ma3 = _applicationObject$ma2["personal-details"]) == null ? void 0 : _applicationObject$ma3["language-preference"]) != null ? _applicationObject$ma : DEFAULT_LANGUAGE_PREFERENCE;
  if (coApplicants.length > 0) {
    coApplicants.forEach(applicant => {
      const preferredLanguage = get(applicant, "[personal-details][language-preference]");
      if (!hasApplicationValue(preferredLanguage)) {
        set(applicant, "[personal-details][language-preference]", defaultLanguage);
      }
    });
  }
  return applicationObject;
};
export const setDefaultSubjectPropertyExistingMortgagesPayoff = applicationObject => {
  const isFlowRefinance = _includesInstanceProperty(FLOWS_FOR_DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF).call(FLOWS_FOR_DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF, applicationObject.flow);
  if (!isFlowRefinance) return applicationObject;
  const existingMortgages = get(applicationObject, "property[existing-mortgages]");
  const mortgagesDetails = get(applicationObject, "mortgage-details[mortgages]");
  if (!isEmpty(existingMortgages)) {
    existingMortgages.forEach((existingMortgage = {}) => {
      const {
        payoff,
        "mortgage-type": mortgageType
      } = existingMortgage;
      if ((!hasApplicationValue(payoff) || payoff === "other") && hasApplicationValue(mortgageType)) {
        const linkedMortgageDataIndex = MORTGAGE_TYPE_PARSER[mortgageType];
        const linkedMortgageData = mortgagesDetails[linkedMortgageDataIndex] || {};
        const shouldSetDefaultPayOff = linkedMortgageData.requested === "requested";
        if (shouldSetDefaultPayOff) {
          set(existingMortgage, "payoff", DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF);
        }
      }
    });
  }
  return applicationObject;
};
export const setDefaultSubjectPropertyExistingMortgagesPayoffEmpty = applicationObject => {
  const isFlowRefinance = _includesInstanceProperty(FLOWS_FOR_DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF).call(FLOWS_FOR_DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF, applicationObject.flow);
  if (!isFlowRefinance) return applicationObject;
  const existingMortgages = get(applicationObject, "property[existing-mortgages]");
  const mortgagesDetails = get(applicationObject, "mortgage-details[mortgages]");
  if (!isEmpty(existingMortgages)) {
    existingMortgages.forEach((existingMortgage = {}) => {
      const {
        payoff,
        "mortgage-type": mortgageType
      } = existingMortgage;
      if (hasApplicationValue(payoff) && payoff === DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF && hasApplicationValue(mortgageType)) {
        const linkedMortgageDataIndex = MORTGAGE_TYPE_PARSER[mortgageType];
        const linkedMortgageData = mortgagesDetails[linkedMortgageDataIndex] || {};
        const shouldEmptyPayOff = linkedMortgageData.requested === "existing";
        if (shouldEmptyPayOff) {
          set(existingMortgage, "payoff", "");
        }
      }
    });
  }
  return applicationObject;
};
export const setDefaultPropertyValue = applicationObject => {
  if (get(applicationObject, "property[details][property-value-index]")) return applicationObject;
  let propertyValueIndex = "E";
  const applicationFlow = get(applicationObject, "flow");
  if (applicationFlow === "purchase-approval") propertyValueIndex = "P";
  set(applicationObject, "property[details][property-value-index]", propertyValueIndex);
  return applicationObject;
};